export interface CheckoutUrls {
  readonly checkoutUrl?: string | null;
  readonly mobileCheckoutUrl?: string | null;
  readonly onlineCheckoutUrl?: string | null;
}

export interface CheckoutDevice {
  readonly userAgent: string;
  readonly mobileClientHint?: boolean;
  readonly viewportWidth: number;
  readonly maxTouchPoints: number;
}

export function selectCheckoutUrl(urls: CheckoutUrls, device: CheckoutDevice): string | undefined {
  const { userAgent, mobileClientHint, viewportWidth, maxTouchPoints } = device;
  const isPhone = mobileClientHint === true || /iPhone|iPod|Android.*Mobile|Windows Phone|webOS|BlackBerry/i.test(userAgent);
  const isTablet = /iPad|Tablet|Android(?!.*Mobile)/i.test(userAgent)
    || (/Macintosh/i.test(userAgent) && maxTouchPoints > 1);
  const isDesktop = (mobileClientHint === false || /Windows NT|Macintosh|X11|Linux x86_64|CrOS/i.test(userAgent)) && !isTablet;
  const useMobileCheckout = isPhone || (viewportWidth < 768 && (isTablet || !isDesktop));
  return (useMobileCheckout ? urls.mobileCheckoutUrl : urls.onlineCheckoutUrl)
    || urls.checkoutUrl
    || (useMobileCheckout ? urls.onlineCheckoutUrl : urls.mobileCheckoutUrl)
    || undefined;
}

export function checkoutUrlForCurrentDevice(urls: CheckoutUrls): string | undefined {
  return selectCheckoutUrl(urls, currentCheckoutDevice());
}

export function checkoutPresentationForCurrentDevice(): "popup" | "redirect" {
  return selectCheckoutUrl({ onlineCheckoutUrl: "popup", mobileCheckoutUrl: "redirect" }, currentCheckoutDevice()) === "popup" ? "popup" : "redirect";
}

function currentCheckoutDevice(): CheckoutDevice {
  const browser = navigator as Navigator & { userAgentData?: { mobile: boolean } };
  return {
    userAgent: browser.userAgent,
    mobileClientHint: browser.userAgentData?.mobile,
    viewportWidth: window.innerWidth,
    maxTouchPoints: browser.maxTouchPoints,
  };
}
